if (!window.Romanics.loadedScript.has('purcomfy-product-wishlist.js')) {
  window.Romanics.loadedScript.add('purcomfy-product-wishlist.js');

  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
      Alpine.data('xPurcomfyWishlist', (config = {}) => ({
        storageKey: 'purcomfy:wishlist',
        sectionId: config.sectionId || '',
        productId: String(config.productId || ''),
        variantId: String(config.variantId || ''),
        handle: config.handle || '',
        title: config.title || '',
        url: config.url || window.location.href,
        image: config.image || '',
        label: config.label || 'ADD WISHLIST',
        addedLabel: config.addedLabel || 'ADDED',
        inWishlist: false,
        loading: false,

        get buttonLabel() {
          return this.inWishlist ? this.addedLabel : this.label;
        },

        init() {
          this.syncState();

          if (this.sectionId) {
            document.addEventListener(`romanics:product-card-variant-select:updated:${this.sectionId}`, (event) => {
              const variant = event.detail?.currentVariant;
              if (variant?.id) this.variantId = String(variant.id);
              this.syncState();
            });
          }

          document.addEventListener('romanics:wishlist:changed', () => this.syncState());
        },

        readItems() {
          try {
            const parsed = JSON.parse(localStorage.getItem(this.storageKey));
            return Array.isArray(parsed) ? parsed : [];
          } catch (error) {
            return [];
          }
        },

        writeItems(items) {
          try {
            localStorage.setItem(this.storageKey, JSON.stringify(items));
          } catch (error) {
            // Keep the UI responsive even when browser storage is unavailable.
          }

          document.dispatchEvent(new CustomEvent('romanics:wishlist:changed', {
            detail: { items }
          }));
        },

        syncState() {
          this.inWishlist = this.readItems().some((item) => String(item.productId) === this.productId);
        },

        add() {
          if (this.loading || this.inWishlist || !this.productId) return;

          this.loading = true;

          if (this.addWithWishlistApp()) return;

          this.addLocal();
          this.loading = false;
        },

        addWithWishlistApp() {
          const swym = window._swat;
          if (!swym || typeof swym.addToWishList !== 'function') return false;

          swym.addToWishList({
            empi: Number(this.productId),
            epi: Number(this.variantId),
            du: this.url
          }, () => {
            this.addLocal();
            this.loading = false;
          }, () => {
            this.addLocal();
            this.loading = false;
          });

          return true;
        },

        addLocal() {
          const items = this.readItems();
          const existingIndex = items.findIndex((item) => String(item.productId) === this.productId);
          const item = {
            productId: this.productId,
            variantId: this.variantId,
            handle: this.handle,
            title: this.title,
            url: this.url,
            image: this.image,
            addedAt: new Date().toISOString()
          };

          if (existingIndex >= 0) {
            items[existingIndex] = { ...items[existingIndex], ...item };
          } else {
            items.push(item);
          }

          this.writeItems(items);
          this.inWishlist = true;
        }
      }));
    });
  });
}
